import React, { useEffect } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useDialogHistory } from '../../../contexts/dialog-context';

export interface CustomDialogProps extends DialogProps {
  onClose?: () => void;
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  onClose,
  ...props
}) => {
  const { registerDialog, unregisterDialog } = useDialogHistory();

  useEffect(() => {
    if (open && onClose) {
      registerDialog(onClose);
      return () => unregisterDialog(onClose);
    }
  }, [open]); // Only trigger when `open` changes

  return <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4, // Adjust radius (e.g., 4 = 32px since MUI spacing is in 8px units)
        },
      }} 
      {...props} 
    />;
};

export default CustomDialog;
